"use client";

import * as React from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function AcrylicSignsHero() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };
  return <section id="acrylicsignshero" className="bg-background relative overflow-hidden py-16 md:py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16 items-center">
          <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
          once: true,
          amount: 0.3
        }} className="max-w-2xl">
            <motion.h1 variants={itemVariants} className="font-default text-4xl font-bold tracking-tight text-foreground sm:text-5xl lg:text-6xl">
              Custom Acrylic Signs and Laser Cutting for Industrial and Facility Applications
            </motion.h1>
            <motion.p variants={itemVariants} className="font-default mt-6 text-lg leading-8 text-muted-foreground">
              Evermark Industrial Solutions produces custom acrylic signs and laser-cut acrylic parts for industrial nameplates, facility identification, control panel labels, and architectural signage. Acrylic is laser-engraved and precision-cut from cast sheet stock in clear, frosted, white, black, and two-color laminate — in standard sizes or cut to any custom shape. Same-day quoting. No minimum order quantity.
            </motion.p>
            <motion.div variants={itemVariants} className="mt-10 flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="w-full sm:w-auto">
                <Link to="/ContactPage">
                  Request a Quote <span aria-hidden="true">→</span>
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="w-full sm:w-auto">
                
              </Button>
            </motion.div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.8,
          ease: "easeOut"
        }} className="relative mx-auto w-full max-w-xl lg:max-w-none">
            <div className="relative aspect-[4/3] w-full overflow-hidden rounded-lg shadow-2xl ring-1 ring-border/50">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/acrylic_signs_hero_flatlay.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/acrylic_signs_hero_flatlay.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/acrylic_signs_hero_flatlay.png-wvc-sizes" alt="Custom laser-cut acrylic signs and nameplates from Evermark Industrial Solutions" className="h-full w-full object-cover object-center" loading="eager" decoding="async" src="https://evermarkindustrial.com/wp-content/uploads/2026/06/Custom-Acryllic-Signs-and-Laser-Cutting.jpg" />
              {}
              <div className="absolute inset-0 rounded-lg ring-1 ring-inset ring-foreground/10 pointer-events-none" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}